export default "/images/vendor/flag-icon-css/flags/1x1/lr.svg?c70ba2e26749882f79c7dfbfffc514f8";